export const generateOptionsFromEnum = (enumObj: Record<string, string>) => {
  return Object.values(enumObj).map((option) => ({
    label: `${option}`,
    value: option,
  }));
};
